import { VISIBLES } from './lib/idiomas';

export default {
  i18n: {
    defaultLocale: 'es',
    // Los visibles (lib/idiomas.js): un idioma oculto no arma rutas como /tr/login.
    locales: VISIBLES,
  },
  fallbackLng: 'es',
};
